import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { CustomHeaderAndFooterQuery } from './CustomHeaderAndFooterQuery.graphql';

export function preloadCustomHeaderAndFooter(spaceKey) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: CustomHeaderAndFooterQuery,
		variables: {
			spaceKey,
		},
	});
}
